import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const TrackingInfoSection = ({
  trackingNumber,
  estimatedDelivery,
  deliveryAddress,
  driverInfo,
  restaurant
}) => {
  const navigate = useNavigate();

  const formatDeliveryTime = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date?.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit'
    });
  };

  const handleTrackOrder = () => {
    navigate('/order-tracking', {
      state: {
        trackingNumber: trackingNumber
      }
    });
  };

  return (
    <div className="bg-card rounded-xl shadow-warm border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="MapPin" size={24} className="text-primary" />
        <h2 className="font-heading font-bold text-xl text-foreground">
          Delivery & Tracking
        </h2>
      </div>

      <div className="space-y-6">
        {/* Tracking Number */}
        <div className="p-4 bg-primary/5 rounded-lg border border-primary/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground font-body">Tracking Number</span>
            <Button
              onClick={handleTrackOrder}
              variant="outline"
              size="sm"
              iconName="ExternalLink"
              iconPosition="right"
            >
              Track Order
            </Button>
          </div>
          <p className="font-mono font-bold text-lg text-primary">{trackingNumber}</p>
        </div>

        {/* Estimated Delivery */}
        <div className="flex items-start space-x-3">
          <Icon name="Clock" size={20} className="text-primary mt-0.5" />
          <div className="flex-1">
            <p className="font-body font-semibold text-foreground mb-1">
              Estimated Delivery Time
            </p>
            <p className="font-body text-muted-foreground">
              {formatDeliveryTime(estimatedDelivery)} (approximately 45 minutes)
            </p>
          </div>
        </div>

        {/* Delivery Address */}
        <div className="flex items-start space-x-3">
          <Icon name="Home" size={20} className="text-primary mt-0.5" />
          <div className="flex-1">
            <p className="font-body font-semibold text-foreground mb-1">
              Delivery Address
            </p>
            <p className="font-body text-muted-foreground">
              {deliveryAddress?.street}<br />
              {deliveryAddress?.city}, {deliveryAddress?.state} {deliveryAddress?.zip}
            </p>
          </div>
        </div>

        {/* Driver Information */}
        {driverInfo && (
          <div className="p-4 bg-muted/30 rounded-lg">
            <div className="flex items-start space-x-3">
              <Icon name="User" size={20} className="text-primary mt-0.5" />
              <div className="flex-1">
                <p className="font-body font-semibold text-foreground mb-1">
                  Driver Information
                </p>
                <p className="font-body text-muted-foreground">
                  {driverInfo?.name}<br />
                  {driverInfo?.phone}<br />
                  <span className="text-xs">{driverInfo?.vehicle}</span>
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Restaurant Contact */}
        <div className="border-t border-border pt-4">
          <div className="flex items-start space-x-3">
            <Icon name="Store" size={20} className="text-primary mt-0.5" />
            <div className="flex-1">
              <p className="font-body font-semibold text-foreground mb-1">
                Restaurant Contact
              </p>
              <p className="font-body text-muted-foreground">
                {restaurant?.name}<br />
                {restaurant?.phone}<br />
                <span className="text-xs">{restaurant?.address}</span>
              </p>
            </div>
          </div>
        </div>

        {/* Info Box */}
        <div className="p-4 bg-accent/10 rounded-lg">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={16} className="text-accent mt-0.5 flex-shrink-0" />
            <p className="text-sm text-foreground">
              You'll receive real-time updates via SMS and email as your order is prepared and delivered.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackingInfoSection;